import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 10V11L11 16L6 11V10L10 10V4L1 4L1 2L12 2V10H16Z", fill: "currentColor" }));
export default SvgArrowDown;
